import { act, useContext, useEffect, useState } from "react"
import { GlobalContext } from "../GlobalContext"
import HeaderDetails from "../shared-components/HeaderDetails"
import { useNavigate, useParams } from "react-router-dom"
import { subscribe } from "../utils/pubsub"

type Props = {}

function ChecklistCodeScanned({ }: Props) {

    const { checklistId } = useParams()
    const {
        tableData,
        sendMessageToWebsocket,
        setShowModal,
        socket,
        loggedIn,
        connectionState
    } = useContext(GlobalContext)
    const navigate = useNavigate()


    useEffect(() => {
        if (checklistId && loggedIn) {
            console.log(`🥎 logged in state: ${loggedIn}, fetching data for checklistId: ${checklistId}`)
            fetchData()
        }
    }, [checklistId, loggedIn])


    const fetchData = () => {
        setShowModal({ "spinner": 'Checklist QR code scanned. Redirecting...' })
        const payload: ObjectStringKeyAnyValue = {
            action: "checklistsClientApp",
            subAction: "checklistCodeScanned",
            checklistId: `${checklistId}`,
        }
        const unsubscribe = subscribe("checklistCodeScannedResponse", data => {
            if (data
                && data.checklistId
                && data.checklistId === checklistId
            ) {
                setShowModal(null)


                if (data.checkPeriodIdToResume) {
                    navigate(`/checklists/${data.checkPeriodIdToResume}`)
                } else {
                    navigate(`/start-checklist/${checklistId}`)
                }
            }
            unsubscribe()
        })
        sendMessageToWebsocket(JSON.stringify(payload))
    }

    return <div className={`w-full flex-1 h-full flex flex-col items-center gap-2`}>

        <HeaderDetails
            titleText={`Checklist QR Code Scanned`}
        />

        <div className={`max-w-3xl w-full px-5 py-5 flex flex-col gap-4 text-center`}>

{/* 
            <p>{loggedIn ? "logged in" : "not logged in"} </p> */}
            {/* <p>{connectionState}</p> */}

        </div>
    </div >


}
export default ChecklistCodeScanned